import { Footer } from '@/components/Footer/Footer'
import { FooterLink, FooterLinkList } from '@/components/Footer/FooterLinkList'
import { MarketSelector } from '@/shared/components/MarketSelector/MarketSelector'
import { useConsent } from '@/shared/consent'
import { useMarket } from '@/shared/market'
import { Grid } from '@mui/material'

import { GlobalContextType } from './global/layout'
import { getUrlFromMenuItem } from './libs/getUrlFromMenuItem'

export type FooterFragmentProps = {
  footer: GlobalContextType['footer']
  lightweight?: boolean
  infoBarOnly?: boolean
}

export const FooterFragment: React.FC<FooterFragmentProps> = ({ footer, lightweight, infoBarOnly }) => {
  const { market } = useMarket()
  const { openPreferences } = useConsent()

  return (
    <Footer wrapper>
      {!lightweight && !infoBarOnly &&
      <>
        {/* <Footer subscribe /> */}
        <Footer main>
          {footer && footer?.menu?.items && footer?.menu?.items?.map(({ name, children, ...menuItem }, index) => {
            const href = getUrlFromMenuItem(menuItem)

            return (
              <Grid item key={index} xs={12} sm={3} md>
                <FooterLinkList>
                  <FooterLink header name={name} href={href} />
                  {/*eslint-disable-next-line*/}
                  {children && children.map(({ name, ...menuItem }, index2) => {
                    const href2 = getUrlFromMenuItem(menuItem)

                    return (
                      <FooterLink key={index2} name={name} href={href2} />
                    )
                  })}
                </FooterLinkList>
              </Grid>
            )
          })}
        </Footer>
      </>
      }
      <Footer
        infoBar
        abn={market.companyInfo.registrationId || undefined}
        copyright={`\u00A9 Copyright ${new Date().getFullYear()} ${market.companyInfo.companyName}.`}
        terms={{
          name: 'Terms of Service',
          href: '/terms-of-service',
        }}
        privacy={{
          name: 'Privacy Policy',
          href: '/privacy-policy',
        }}
        marketSelector={<MarketSelector />}
        onCookiePreferences={openPreferences}
      />
      {!infoBarOnly && <Footer bottom />}
    </Footer>
  )
}
